import { graphql } from 'src/gql';

export const ContactWebHouseholdFragment = graphql(/* GraphQL */ `
  fragment ContactWebHousehold on Household {
    id
    name
    salesforceAccountId
    savvyAum
    householdStage
    advisor {
      id
      name
    }
    householdTags {
      id
      organizationHouseholdTag {
        id
        name
        isSmart
        organizationHouseholdCategory {
          id
          name
          hexColorCode
          emoji
        }
      }
    }
  }
`);

export const ContactWebTabFragment = graphql(/* GraphQL */ `
  fragment ContactWebTab on Query {
    centerOfInfluenceReps {
      id
      name
      description
      photoUrl
      specialties
      outgoingProfessionalRelationships {
        id
        relationshipType
        referredOn
        createdAt
        target {
          __typename
          ... on Household {
            ...ContactWebHousehold
          }
          ... on CenterOfInfluenceRep {
            id
          }
        }
      }
      incomingProfessionalRelationships {
        id
        relationshipType
        referredOn
        createdAt
        source {
          __typename
          ... on Household {
            ...ContactWebHousehold
          }
          ... on CenterOfInfluenceRep {
            id
          }
        }
      }
    }
  }
`);

export const ContactWebQuery = graphql(/* GraphQL */ `
  query ContactWeb {
    ...ContactWebTab
  }
`);

export const ContactWebModalQuery = graphql(/* GraphQL */ `
  query ContactWebModal {
    ...ContactWebTab
  }
`);
